{
  "activeMiners": "فعال مائنرز",
  "approvedRewards": "منظور شدہ انعامات",
  "assetOverview": "اکاؤنٹ اور اثاثے",
  "buyExalt": "EXALT خریدیں",
  "community": "کمیونٹی",
  "dashboardSubtitle": "پیشہ ورانہ ڈیجیٹل اثاثہ ایکسچینج",
  "dashboardTitle": "ڈیش بورڈ",
  "displayCurrency": "ڈسپلے کرنسی",
  "earn": "کمائیں",
  "estimatedExchangeWalletValue": "تخمینی ایکسچینج والٹ ویلیو",
  "exchangeActivity": "ایکسچینج سرگرمی",
  "hideBalances": "بیلنس چھپائیں",
  "leaderboard": "لیڈر بورڈ",
  "live": "لائیو",
  "liveMarketBoard": "● لائیو مارکیٹ بورڈ",
  "loading": "لوڈ ہو رہا ہے...",
  "marketCap": "مارکیٹ کیپ",
  "marketStatus": "مارکیٹ اسٹیٹس",
  "miningPool": "مائننگ پول",
  "noActivityYet": "ابھی کوئی سرگرمی نہیں",
  "notifications": "اطلاعات",
  "pendingRewards": "زیر التواء انعامات",
  "portfolioValue": "پورٹ فولیو ویلیو",
  "quickActions": "فوری ایکشنز",
  "readyTradingWithdrawal": "ٹریڈنگ یا ودڈرال کے لیے تیار",
  "recentActivity": "حالیہ سرگرمی",
  "recentOrders": "حالیہ آرڈرز",
  "refresh": "ریفریش",
  "refreshDashboard": "ڈیش بورڈ ریفریش کریں",
  "security": "سیکیورٹی اور تصدیق",
  "showBalances": "بیلنس دکھائیں",
  "submitListing": "لسٹنگ جمع کریں",
  "topGainer": "سب سے زیادہ بڑھنے والا",
  "topLoser": "سب سے زیادہ گرنے والا",
  "totalPortfolioValue": "کل پورٹ فولیو ویلیو",
  "trendingCoins": "ٹرینڈنگ کوائنز",
  "unavailable": "دستیاب نہیں",
  "viewMarketBoard": "مارکیٹ بورڈ دیکھیں",
  "waitingAdminApproval": "ایڈمن منظوری کا انتظار",
  "walletStatus": "والٹ اسٹیٹس"
}